import { graphql } from "gatsby";
import React, { FC } from "react";

import { usePageFullPath } from "../../../hooks/use-page-full-path";
import { useEventsLabels } from "../../events/use-events-labels";
import { useGetEvents } from "../../events/use-get-events";
import { EventsGridInner } from "./events-grid-inner";

export interface EventsGridSectionProps extends Queries.EventsGridSectionDataFragment {}

export const EventsGridSection: FC<EventsGridSectionProps> = ({ detailPage }) => {
  const labels = useEventsLabels();
  const eventsData = useGetEvents();
  const detailPageFullPath = usePageFullPath(detailPage?.id);

  return (
    <EventsGridInner labels={labels} eventDetailPagePath={detailPageFullPath} {...eventsData} />
  );
};

export const query = graphql`
  fragment EventsGridSectionData on ContentfulEventsGridSection {
    detailPage {
      id
    }
  }
`;
